export default __webpack_public_path__ + "static/media/1534.eb3a2d44.png";